import {
  MDBCheckbox,
  MDBCol,
  MDBInput,
  MDBRadio,
  MDBRow,
} from "mdb-react-ui-kit";
import React from "react";
import { useTranslation } from "react-i18next";

function NumbersAccountInfo({
  register,
  errors,
  watch,
  setValue,
  portingType,
  clearErrors,
}) {
  const { t, i18n } = useTranslation();
  return (
    <>
      <div className="enter-account-info-container">
        <div className="pb-3">
          <h5>Enter Account Info {portingType === 3 ? "(Optional)" : ""}</h5>
          <p className="small my-3 text-secondary">
            For Security purposes, your current service provider requires you to
            enter the following info EXACTLY as they have in Copy of Bill or
            CSR. You may need to contact your service provider to get specifies
          </p>
          <MDBRadio
            name="flexRadioDefault"
            id="flexRadioDefault1"
            label="Business"
            checked
          />

          {/* only for toll free */}
          {portingType === 2 && (
            <div className="my-2 d-flex align-items-start">
              <p>Number Type to be Ported:</p>
              <MDBRadio
                className="ms-3"
                name="flexRadioDefault2"
                id="flexRadioDefault2"
                label="Toll Free"
                checked
              />

              <div>
                <MDBRadio
                  name="flexRadioDefault3"
                  className="ms-3"
                  id="flexRadioDefault3"
                  label="Full Port"
                  checked={parseInt(watch("acc_info.porting_num_type")) === 1}
                  onClick={() =>
                    setValue("acc_info.porting_num_type", 1, {
                      shouldDirty: true,
                    })
                  }
                />
                <MDBRadio
                  name="flexRadioDefault4"
                  className="ms-3"
                  id="flexRadioDefault4"
                  label="Partial Port"
                  checked={parseInt(watch("acc_info.porting_num_type")) === 2}
                  onClick={() =>
                    setValue("acc_info.porting_num_type", 2, {
                      shouldDirty: true,
                    })
                  }
                />
              </div>
            </div>
          )}

          <h5 className="mt-2">Name on Account</h5>
          {/*{(portingType === 1 || portingType === 3) && (
            <MDBRow>
              <MDBCol sm={12} md={6} lg={6} xl={6} className="pe-0">
                <div className="tel-numbers">
                  <strong>{t("title")}*</strong>
                </div>
                <MDBInput
                  type="text"
                  value={watch("acc_info.title")}
                  onChange={(e) => {
                    clearErrors("acc_info.title");
                    setValue("acc_info.title", e.target.value, {
                      shouldDirty: true,
                    });
                  }}
                />
                {errors?.acc_info?.title && (
                  <p className="text-danger">
                    {errors?.acc_info?.title?.message}
                  </p>
                )}
              </MDBCol>
            </MDBRow>
          )} */}
          <MDBRow>
            <MDBCol size={6}>
              <div className="tel-numbers">
                <strong>{t("Auth First Name")}*</strong>
              </div>
              <div>
                <MDBInput
                  type="text"
                  maxLength={20}
                  value={watch("acc_info.first_name")}
                  onChange={(e) => {
                    clearErrors("acc_info.first_name");
                    setValue("acc_info.first_name", e.target.value, {
                      shouldDirty: true,
                    });
                  }}
                />
                {errors?.acc_info?.first_name && (
                  <p className="text-danger">
                    {errors?.acc_info?.first_name?.message}
                  </p>
                )}
                <small className="text-secondary">
                  (Enter the name of the person authorized to make the changes to
                  the account)
                </small>
              </div>
            </MDBCol>
            <MDBCol size={6}>
              <div className="tel-numbers">
                <strong>Auth Last Name*</strong>
              </div>
              <MDBInput
                type="text"
                maxLength={20}
                value={watch("acc_info.last_name")}
                onChange={(e) => {
                  clearErrors("acc_info.last_name");
                  setValue("acc_info.last_name", e.target.value, {
                    shouldDirty: true,
                  });
                }}
              />
              {errors?.acc_info?.last_name && (
                <p className="text-danger">
                  {errors?.acc_info?.last_name?.message}
                </p>
              )}
            </MDBCol>
            <MDBCol size={6}>
              <div className="tel-numbers mt-4">
                <strong>{t("companyName")}*</strong>
              </div>
              <div>
                <MDBInput
                  type="text"
                  maxLength={32}
                  value={watch("acc_info.company_name")}
                  onChange={(e) => {
                    clearErrors("acc_info.company_name");
                    setValue("acc_info.company_name", e.target.value, {
                      shouldDirty: true,
                    });
                  }}
                />
                {errors?.acc_info?.company_name && (
                  <p className="text-danger">
                    {errors?.acc_info?.company_name?.message}
                  </p>
                )}
                <small className="text-secondary">
                  (Enter the company name exactly as it appears on your phone
                  bill)
                </small>
              </div>
            </MDBCol>
            <MDBCol size={6}>
              {(portingType === 2) && (
                <>
                  <div className="tel-numbers" style={{marginTop:'21px'}}>
                    <strong>Contact Title*</strong>
                  </div>
                  <MDBInput
                    type="text"
                    maxLength={50}
                    value={watch("acc_info.contact_title")}
                    onChange={(e) => {
                      clearErrors("acc_info.contact_title");
                      setValue("acc_info.contact_title", e.target.value, {
                        shouldDirty: true,
                      });
                    }}
                  />
                  {errors?.acc_info?.contact_title && (
                    <p className="text-danger">
                      {errors?.acc_info?.contact_title?.message}
                    </p>
                  )}
                </>
              )}
              
              {(portingType === 1 || portingType === 3) && (
                <>
                  <div className="tel-numbers mt-4">
                    <strong>{t("CurrentCarrierName")}*</strong>
                  </div>
                  <MDBInput
                    type="text"
                    maxLength={25}
                    value={watch("acc_info.curr_carrier_name")}
                    onChange={(e) => {
                      clearErrors("acc_info.curr_carrier_name");
                      setValue("acc_info.curr_carrier_name", e.target.value, {
                        shouldDirty: true,
                      });
                    }}
                  />
                  {errors?.acc_info?.curr_carrier_name && (
                    <p className="text-danger">
                      {errors?.acc_info?.curr_carrier_name?.message}
                    </p>
                  )}
                </>
              )}
            </MDBCol>
          </MDBRow>
        </div>

        <div className="routing-border m-0 p-0"></div>

        <h5 className="mt-3">Others</h5>
        <MDBRow className="pb-4">
          <MDBCol sm={12} md={6} lg={6} xl={6} style={{ minHeight: "100px" }}>
            <div className="tel-numbers">
              <strong>Account Number*</strong>
            </div>
            <MDBInput
              type="text"
              maxLength={20}
              value={watch("acc_info.acc_num")}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              onChange={(e) => {
                clearErrors("acc_info.acc_num");
                setValue("acc_info.acc_num", e.target.value, {
                  shouldDirty: true,
                });
              }}
            />
            {portingType !== 3 && (
              <div className="tn-checkbox mt-2">
                <div className="d-flex align-items-center">
                  <label
                    className={`big-checkbox ${watch("acc_info.is_mobile_num") ? "checked" : ""
                      }`}
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Tab") e.stopPropagation();
                      if (e.key === " " || e.key === "Enter") {
                        e.preventDefault();
                        setValue("acc_info.is_mobile_num", !watch("acc_info.is_mobile_num"), { shouldDirty: true });
                      }
                    }}
                  >
                    <input
                      type="checkbox"
                      id="checkboxNoLabel"
                      tabIndex={-1}
                      checked={watch("acc_info.is_mobile_num") ?? false}
                      onChange={(e) => {
                        setValue("acc_info.is_mobile_num", e.target.checked, {
                          shouldDirty: true,
                        });
                      }}
                    />
                    <span className="box">
                      <svg
                        className="checkmark"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M18.7071 8.70711L10.5 16.9142L6.29289 12.7071L7.70711 11.2929L10.5 14.0858L17.2929 7.29289L18.7071 8.70711Z"
                          fill="#FFFFFF"
                        />
                      </svg>
                    </span>
                  </label>
                  <small
                    onClick={() =>
                      setValue(
                        "acc_info.is_mobile_num",
                        !watch("acc_info.is_mobile_num")
                      )
                    }
                    className="ms-2 text-secondary"
                    style={{ cursor: "pointer", fontSize: "12px" }}
                  >
                    Check here if the number you are requesting to transfer is a
                    mobile number
                  </small>
                </div>
              </div>
            )}

            {errors?.acc_info?.acc_num && (
              <p className="text-danger">
                {errors?.acc_info?.acc_num?.message}
              </p>
            )}
          </MDBCol>
          <MDBCol sm={12} md={6} lg={6} xl={6} style={{ minHeight: "100px" }}>
            <div className="tel-numbers">
              <strong>Billing Telephone Number*</strong>
            </div>
            <MDBInput
              type="text"
              maxLength={10}
              value={watch("acc_info.bill_tele_num")}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              onChange={(e) => {
                clearErrors("acc_info.bill_tele_num");
                setValue(
                  "acc_info.bill_tele_num",
                  e.target.value !== "" && !Number.isNaN(Number(e.target.value))
                    ? parseInt(e.target.value)
                    : "",
                  {
                    shouldDirty: true,
                  }
                );
              }}
            />
            {errors?.acc_info?.bill_tele_num && (
              <p className="text-danger">
                {errors?.acc_info?.bill_tele_num?.message}
              </p>
            )}
          </MDBCol>
          {/* <MDBCol sm={12} md={6} lg={6} xl={6} >
            {(portingType === 1 || portingType === 3) && (
              <>
                <div className="tel-numbers">
                  <strong>Name Listed on Account*</strong>
                </div>
                <MDBInput
                  type="text"
                  value={watch("acc_info.name_listed_on_acc")}
                  onChange={(e) => {
                    clearErrors("acc_info.name_listed_on_acc");
                    setValue("acc_info.name_listed_on_acc", e.target.value, {
                      shouldDirty: true,
                    });
                  }}
                />
                {errors?.acc_info?.name_listed_on_acc && (
                  <p className="text-danger">
                    {errors?.acc_info?.name_listed_on_acc?.message}
                  </p>
                )}
              </>
            )}
          </MDBCol> */}
          {portingType === 2 && (
             <>
          <MDBCol sm={12} md={6} lg={6} xl={6}>
            <div className="tel-numbers">
              <strong>Authorized Customer Fax</strong>
            </div>
            <MDBInput
              type="text"
              value={watch("acc_info.authorized_customer_fax")}
              onChange={(e) => {
                clearErrors("acc_info.authorized_customer_fax");
                setValue("acc_info.authorized_customer_fax",e.target.value,{
                    shouldDirty: true,
                  }
                );
              }}
            />
            {errors?.acc_info?.authorized_customer_fax && (
              <p className="text-danger">
                {errors?.acc_info?.authorized_customer_fax?.message}
              </p>
            )}
          </MDBCol>
          </>
          )}

          {portingType === 1 && (
            <>
              <MDBCol sm={12} md={6} lg={6} xl={6}>
                <div className="tel-numbers">
                  <strong>Caller ID Name*</strong>
                </div>
                <MDBInput
                  type="text"
                  maxLength={15}
                  value={watch("acc_info.caller_id_name")}
                  onChange={(e) => {
                    clearErrors("acc_info.caller_id_name");
                    setValue("acc_info.caller_id_name", e.target.value, {
                      shouldDirty: true,
                    });
                  }}
                />
                {errors?.acc_info?.caller_id_name && (
                  <p className="text-danger">
                    {errors?.acc_info?.caller_id_name?.message}
                  </p>
                )}
              </MDBCol>
              <MDBCol sm={12} md={6} lg={6} xl={6}>
                <div className="tel-numbers">
                  <strong>Account PIN</strong>
                </div>
                <MDBInput
                  type="text"
                  maxLength={15}
                  value={watch("acc_info.acc_pin")}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={(e) => {
                    clearErrors("acc_info.acc_pin");
                    setValue("acc_info.acc_pin", e.target.value, {
                      shouldDirty: true,
                    });
                  }}
                />
                {errors?.acc_info?.acc_pin && (
                  <p className="text-danger">
                    {errors?.acc_info?.acc_pin?.message}
                  </p>
                )}
              </MDBCol>
            </>
          )}
        </MDBRow>
      </div>
    </>
  );
}

export default NumbersAccountInfo;
